module.exports = __webpack_public_path__ + "static/1-9c2b4576dc608616c50bf4e1a06a07ed.jpg";